// 订单与合同：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 采购订单
export const buy = Object.freeze({
  "buyOrders.title": "我的购买订单",
  "buyOrders.orderNumber": "订单编号",
  "buyOrders.productTitle": "标题",
  "buyOrders.partNumber": "料号",
  "buyOrders.image": "图片",
  "buyOrders.quantity": "数量",
  "buyOrders.totalAmount": "总金额",
  "buyOrders.status": "订单状态",
  "buyOrders.time": "时间",
  "buyOrders.actions": "操作",
  "buyOrders.review": "去评价",
  "buyOrders.viewReview": "查看评价",
  "buyOrders.viewDetails": "查看详情",
  "buyOrders.payCommission": "支付佣金",
  "buyOrders.uploadPaymentProof": "上传付款凭证",
  "buyOrders.confirmReceipt": "确认收货",
});

// 联系人
export const contact = Object.freeze({
  "contactDialog.noTags": "暂无可选标签",
  "contactDialog.contact": "联系人",
  "contactDialog.enterContactName": "请填写联系人姓名",
  "contactDialog.ms": "女士",
  "contactDialog.mr": "先生",
  "contactDialog.phone": "联系电话",
  "contactDialog.enterPhone": "请填写联系电话",
  "contactDialog.wechatNumber": "微信号码",
  "contactDialog.enterWechatNumber": "请填写微信号码",
  "contactDialog.hometown": "联系人籍贯",
  "contactDialog.enterHometown": "请填写联系人籍贯",
  "contactDialog.character": "联系人性格",
  "contactDialog.hobbies": "联系人爱好",
  "contactDialog.bindNegotiator": "绑定谈判人",
  "contactDialog.searchNegotiatorNameOrPhone":
    "搜索需要绑定的谈判人姓名/手机号码",
  "contactDialog.setDefault": "设为默认联系人",
  "contactDialog.cancel": "取消",
  "contactDialog.gender": "性别",
  "contactDialog.characterShort": "性格",
  "contactDialog.hobbiesShort": "爱好",
  "contactDialog.searchNegotiator": "搜索需要绑定的谈判人",
  "contactDialog.chooseNegotiator": "选择谈判人",
  "contactDialog.noMore": "没有更多了",
  "contactDialog.choosePerson": "选择人员",
  "contactDialog.newContact": "新建联系人",
  "contactDialog.changeContact": "更换联系人",
  "contactDialog.choosePersonHint": "搜索并选择需要添加的人员",
  "contactDialog.newContactHint": "补充联系人资料，用于订单沟通与后续协作",
  "contactDialog.changeContactHint":
    "选择需要使用的联系人，并可同步设置默认联系人",
  "contactDialog.confirmAdd": "确认添加",
  "contactDialog.confirmChange": "确认更换",
  "contactDialog.searchPersonName": "搜索人员姓名",
  "contactDialog.searchContactNameOrPhone": "搜索联系人姓名或电话",
  "contactDialog.noMatchingContacts": "未找到匹配的联系人",
  "contactDialog.noContactsToChange": "暂无联系人可更换",
  "contactDialog.noMatchingPeople": "未找到匹配的人员",
  "contactDialog.searchPersonToAdd": "输入姓名搜索需要添加的人员",
  "contactDialog.supplierIdRequired": "供应商ID不能为空",
  "contactDialog.unnamedPerson": "未命名人员",
});

// 购物与谈判人
export const broker = Object.freeze({
  "mobileCart.title": "购物车",
  "mobileCart.totalPrefix": "共",
  "mobileCart.totalSuffix": "件商品",
  "mobileCart.edit": "编辑",
  "mobileCart.selectAll": "全选",
  "mobileCart.total": "合计：",
  "mobileCart.checkout": "结算({count})",
  "mobileCart.delete": "删除",
  "mobileCart.empty": "您的购物车是空的, 快去逛逛吧",
  "mobileCart.browse": "去逛逛",
  "mobileBroker.notBroker": "你不是谈判人，申请成为谈判人，然后一个申请表单",
  "mobileBroker.underReview": "审核中",
  "mobileBroker.apply": "申请成为谈判人",
  "mobileBroker.reviewing": "正在审核中",
  "mobileBroker.applicationInfo": "申请信息",
  "mobileBroker.shopName": "店铺名",
  "mobileBroker.shopNamePlaceholder": "请输入店铺名称",
  "mobileBroker.ownerName": "货主姓名",
  "mobileBroker.ownerNamePlaceholder": "请输入真实姓名",
  "mobileBroker.ownerNameInvalid": "请输入正确的姓名",
  "mobileBroker.ownerPhone": "货主手机号",
  "mobileBroker.ownerPhonePlaceholder": "请输入11位手机号",
  "mobileBroker.ownerPhoneInvalid": "请输入正确的手机号",
  "mobileBroker.ownerWechat": "货主微信号",
  "mobileBroker.ownerWechatPlaceholder": "请输入常用微信号",
  "mobileBroker.ownerWechatRequired": "请输入微信号",
  "mobileBroker.reason": "店铺申请理由",
  "mobileBroker.reasonPlaceholder": "请简要说明申请原因",
  "mobileBroker.reasonRequired": "请填写申请理由",
  "mobileBroker.submitting": "提交中...",
  "mobileBroker.submit": "提交申请",
  "mobileBroker.succeeded": "申请成功!",
  "mobileBroker.failed": "提交失败",
  "mobileBroker.retryLater": "提交失败，请稍后重试",
});

// 移动结算
export const checkout = Object.freeze({
  "mobileCheckout.title": "订单结算台",
  "mobileCheckout.chooseAddress": "请选择配送地址",
  "mobileCheckout.goodsTotal": "共 {count} 件商品，合计：",
  "mobileCheckout.orderAmount": "订单总金额：",
  "mobileCheckout.coupon": "优惠券：",
  "mobileCheckout.noCoupon": "无优惠券可用",
  "mobileCheckout.deliveryFee": "配送费用：",
  "mobileCheckout.chooseAddressFirst": "请先选择配送地址",
  "mobileCheckout.paymentMethod": "支付方式",
  "mobileCheckout.balancePayment": "余额支付（可用 ¥ {balance} 元）",
  "mobileCheckout.buyerNotePlaceholder": "选填：买家留言（50字内）",
  "mobileCheckout.amountDue": "实付款：",
  "mobileCheckout.submitOrder": "提交订单",
  "mobileCheckout.paymentSuccess": "支付成功",
});

// 移动订单组件
export const mobileComponents = Object.freeze({
  "mobileOrder.splitOrder": "拆单",
  "mobileOrder.split": "已拆分",
  "mobileOrder.fastOrder": "快单",
  "mobileOrder.mergedOrder": "合并订单",
  "mobileOrder.contractAndOrderNumbers": "合同、订单编号",
  "mobileOrder.contractNumber": "合同编号",
  "contractNumber.partiesRequired": "请先选择不同的买卖双方公司",
  "contractNumber.companyChanged": "公司选择已变化，请重新确认编号",
  "contractNumber.reviewFiles": "合同编号发生变化，请核对已下载或上传的合同文件后再提交",
  "contractNumber.unavailable": "合同编号暂时无法生成，请稍后重试；持续失败请联系管理员",
  "contractNumber.companyCodeRequired": "对方公司尚未配置编码，请先完善公司资料",
  "contractNumber.invalidCompanyCode": "对方公司编码格式不正确，请先完善公司资料",
  "contractNumber.expired": "合同编号已失效，请重新获取并核对合同文件",
  "contractNumber.alreadySubmitted": "该表单已提交，请刷新查看原合同",
  "contractNumber.businessRequired": "仅商务可分配合同编号",
  "contractNumber.purchasePending": "选择卖方公司后自动生成",
  "contractNumber.salePending": "选择买方公司后自动生成",
  "mobileOrder.orderNumber": "订单编号",
  "mobileOrder.goodsNumber": "商品编号",
  "mobileOrder.close": "关闭",
  "mobileOrder.copy": "复制",
  "mobileOrder.brand": "品牌",
  "mobileOrder.title": "标题",
  "mobileOrder.quantity": "数量",
  "mobileOrder.unitPrice": "单价",
  "mobileOrder.quantityBeforeSplit": "拆分前数量",
  "mobileOrder.contacts": "联系人",
  "mobileOrder.details": "详情",
  "mobileOrder.collapseTradeInfo": "收起交易信息",
  "mobileOrder.moreTradeInfo": "更多交易信息",
  "mobileOrder.viewDetails": "查看详情",
  "mobileOrder.moreActions": "更多操作",
  "mobileOrder.more": "更多",
  "mobileOrder.inviteSeller": "邀请货主",
  "mobileOrder.generateSalesOrder": "生成销售订单",
  "mobileOrder.generatePurchaseOrder": "生成采购订单",
  "mobileOrder.cancel": "取消",
  "mobileOrder.inspectGoods": "验货",
  "mobileOrder.inspectionDetails": "验货详情",
  "mobileOrder.rateNow": "去评价",
  "mobileOrder.viewRating": "查看评价",
  "mobileOrder.uploadInvoice": "上传发票",
  "mobileOrder.confirmPaymentReceived": "确认收款",
  "mobileOrder.uploadShippingInfo": "上传物流信息",
  "mobileOrder.uploadPaymentProof": "上传付款凭证",
  "mobileOrder.confirmDelivery": "确认收货",
  "mobileOrder.company": "公司",
  "mobileOrder.callNumber": "拨打{phone}",
  "mobileOrder.phone": "电话",
  "mobileOrder.splitAction": "拆分",
  "mobileOrder.revokeAction": "撤回",
  "mobileOrder.buy": "采购",
  "mobileOrder.sell": "销售",
  "mobileOrder.copySuccess": "复制成功",
  "mobileOrder.copyFailed": "复制失败",
  "mobileOrder.notice": "提示",
  "mobileOrder.revokeSplitConfirm": "确认撤回已拆分的订单？",
  "mobileOrder.confirmRevoke": "确认撤回",
  "mobileOrder.revokeSuccess": "撤回成功",
  "mobileOrder.paymentProofRequired": "请上传付款凭证！",
  "mobileOrder.paymentProofUploaded": "上传付款凭证成功！",
  "mobileOrder.shippingAddressRequired": "请选择收货地址！",
  "mobileOrder.proofOrRemarkRequired": "请上传凭证或备注！",
  "mobileOrder.shippingInfoUploaded": "上传物流信息成功！",
  "mobileOrder.deliveryConfirmed": "确认收货成功！",
  "mobileOrder.paymentConfirmed": "确认收款成功！",
  "mobileOrder.invoiceRequired": "请至少上传一份发票！",
  "mobileOrder.invoiceUploaded": "上传发票成功！",
  "mobileOrder.filter": "筛选",
  "mobileOrder.searchAll": "全部搜索",
  "mobileOrder.searchName": "名称搜索",
  "mobileOrder.searchPartNumber": "料号搜索",
  "mobileOrder.partNumberOrNameSearch": "料号、名称搜索",
  "mobileOrder.nameSearch": "名称搜索",
  "mobileOrder.partNumberSearch": "料号搜索",
  "mobileOrder.invite": "邀请",
});

// 移动订单
export const mobile = Object.freeze({
  "mobileOrders.myOrders": "我的订单",
  "mobileOrders.all": "全部",
  "mobileOrders.awaitingPayment": "待支付",
  "mobileOrders.awaitingShipment": "待发货",
  "mobileOrders.awaitingReceipt": "待收货",
  "mobileOrders.awaitingReview": "待评价",
  "mobileOrders.submitted": "提交成功",
  "mobileOrders.paymentSucceeded": "支付成功",
});

// 移动购物车
export const mobileCart = Object.freeze({
  "mobileShopCart.goodsList": "商品清单",
  "mobileShopCart.unnamedProduct": "未命名商品",
  "mobileShopCart.partNumber": "料号",
  "mobileShopCart.unitPrice": "单价",
  "mobileShopCart.quantity": "数量",
  "mobileShopCart.pieceUnit": "件",
  "mobileShopCart.sellerInfo": "卖家资料",
  "mobileShopCart.companyName": "公司名称",
  "mobileShopCart.contactPerson": "联系人",
  "mobileShopCart.contactPhone": "联系电话",
  "mobileShopCart.noPendingProducts": "暂无待提交商品",
  "mobileShopCart.estimatedTotal": "预估合计",
  "mobileShopCart.itemCount": "共 {count} 项",
  "mobileShopCart.finalAmountHint": "最终金额以订单确认为准",
  "mobileShopCart.approximately": "约",
  "mobileShopCart.buyerInfo": "买家信息",
  "mobileShopCart.enterCompanyName": "请填写公司名称",
  "mobileShopCart.taxNumber": "公司税号",
  "mobileShopCart.enterTaxNumber": "请填写公司税号",
  "mobileShopCart.enterContactPerson": "请填写联系人",
  "mobileShopCart.contactInfo": "联系方式",
  "mobileShopCart.enterPhone": "请填写手机号",
  "mobileShopCart.deliveryAddress": "交货地址",
  "mobileShopCart.enterDeliveryAddress": "请填写交货地址",
  "mobileShopCart.attachments": "附件信息",
  "mobileShopCart.uploadOrderInfo": "上传订单信息",
  "mobileShopCart.maxTenFiles": "最多上传 10 个文件",
  "mobileShopCart.orderInfo": "订单信息",
  "mobileShopCart.infoUsageHint": "信息仅用于本次采购意向沟通",
  "mobileShopCart.submitting": "正在提交",
  "mobileShopCart.checkoutTitle": "提交采购意向单",
  "mobileShopCart.submitPurchaseIntent": "提交采购意向",
  "mobileShopCart.loginFirst": "请先登录",
  "mobileShopCart.submitSuccess": "采购意向单提交成功！",
  "mobileShopCart.cartTitle": "购物车",
  "mobileShopCart.done": "完成",
  "mobileShopCart.manage": "管理",
  "mobileShopCart.searchPlaceholder": "搜索商品料号、名称",
  "mobileShopCart.loading": "正在加载",
  "mobileShopCart.product": "商品",
  "mobileShopCart.selectProduct": "选择{product}",
  "mobileShopCart.noImage": "暂无图片",
  "mobileShopCart.outOfStock": "库存不足",
  "mobileShopCart.lowStock": "库存紧张",
  "mobileShopCart.decreaseProductQuantity": "减少{product}数量",
  "mobileShopCart.editQuantity": "手动输入数量，当前{count}",
  "mobileShopCart.increaseProductQuantity": "增加{product}数量",
  "mobileShopCart.favorite": "收藏",
  "mobileShopCart.delete": "删除",
  "mobileShopCart.emptyCart": "采购清单为空",
  "mobileShopCart.noSearchResults": "没有找到匹配的商品，换个关键词试试",
  "mobileShopCart.emptyCartHint": "挑选合适的商品后，可在这里统一结算",
  "mobileShopCart.clearSearch": "清除搜索",
  "mobileShopCart.shopNow": "去采购",
  "mobileShopCart.changeQuantity": "修改购买数量",
  "mobileShopCart.currentStock": "当前库存",
  "mobileShopCart.pieces": "{count} 件",
  "mobileShopCart.purchaseQuantity": "购买数量",
  "mobileShopCart.decreaseInputQuantity": "减少输入数量",
  "mobileShopCart.increaseInputQuantity": "增加输入数量",
  "mobileShopCart.quantityLimit": "购买数量不可超过当前库存 {count} 件",
  "mobileShopCart.currentOutOfStock": "当前商品库存不足",
  "mobileShopCart.cancel": "取消",
  "mobileShopCart.confirm": "确定",
  "mobileShopCart.selectedDetails": "已选商品明细",
  "mobileShopCart.selectedSummary": "{kinds} 种商品，共 {count} 件",
  "mobileShopCart.totalQuantity": "合计数量：{count} 件",
  "mobileShopCart.selectAll": "全选",
  "mobileShopCart.viewDetails": "查看明细",
  "mobileShopCart.moveToFavorites": "移入收藏",
  "mobileShopCart.syncing": "同步中...",
  "mobileShopCart.selectProductFirst": "请先选择商品",
  "mobileShopCart.favoriteComingSoon": "收藏功能即将开放",
  "mobileShopCart.selectToDelete": "请先选择要删除的商品",
  "mobileShopCart.confirmDeleteSelected": "确定删除已选的 {count} 种商品吗？",
  "mobileShopCart.confirmRemoveProduct": "确定将该商品移出采购清单吗？",
  "mobileShopCart.deleteProduct": "删除商品",
  "mobileShopCart.deleteSuccess": "删除成功",
  "mobileShopCart.stockLimitReached": "已达到库存上限",
  "mobileShopCart.invalidQuantity": "请输入正确的购买数量",
  "mobileShopCart.maximumQuantity": "当前最多可购买 {count} 件",
  "mobileShopCart.loadFailed": "采购清单加载失败，请稍后重试",
  "mobileShopCart.multipleCurrencies": "多币种商品",
  "mobileShopCart.multipleCurrenciesHint":
    "所选商品包含多个币种，提交后将拆分为多个订单，是否继续？",
  "mobileShopCart.continueOrder": "继续下单",
  "mobileShopCart.syncFailed": "采购清单同步失败",
});

// 移动交易订单
export const mobileTransactions = Object.freeze({
  "transactionOrders.title": "交易订单中心",
  "transactionOrders.all": "全部",
  "transactionOrders.buy": "采购",
  "transactionOrders.sell": "销售",
  "transactionOrders.follow": "意向",
  "transactionOrders.pendingNotice": "您现在有{count}个{unit}",
  "transactionOrders.pending": "待处理",
  "transactionOrders.loginRequired": "请先登录！",
  "transactionOrders.negotiatorRequired": "你不是谈判人，请申请成为谈判人",
  "transactionOrders.underReview": "审核中",
  "transactionOrders.applyNegotiator": "申请成为谈判人",
  "transactionOrders.loading": "加载中...",
  "transactionOrders.noMore": "我们是有底线的",
  "transactionOrders.backToTop": "回到顶部",
  "transactionOrders.noOrders": "暂无订单数据",
  "transactionOrders.noFollowOrders": "暂无意向订单数据",
  "transactionOrders.followUnit": "跟单",
  "transactionOrders.orderUnit": "订单",
  "transactionOrders.underReviewMessage": "正在审核中",
});

// 订单详情
export const details = Object.freeze({
  "preOrderDetail.title": "商品订单详情",
  "preOrderDetail.goodsCode": "商品编号",
  "preOrderDetail.edit": "编辑",
  "preOrderDetail.imageLoading": "图片加载中",
  "preOrderDetail.unitPrice": "单价",
  "preOrderDetail.stock": "库存",
  "preOrderDetail.viewGoods": "查看商品详情",
  "preOrderDetail.viewDetails": "查看详情",
  "preOrderDetail.subOrders": "商品子订单",
  "preOrderDetail.orderNumber": "订单编号",
  "preOrderDetail.quantity": "数量",
  "preOrderDetail.noSubOrders": "暂无子订单",
  "preOrderDetail.sellerContacts": "卖方联系人",
  "preOrderDetail.buyerContacts": "买方联系人",
  "preOrderDetail.negotiator": "谈判人",
  "preOrderDetail.business": "商务",
  "preOrderDetail.noContacts": "暂无联系人信息",
  "preOrderDetail.changeRecords": "商品信息修改记录",
  "preOrderDetail.changedAt": "修改时间",
  "preOrderDetail.goodsPrice": "商品单价",
  "preOrderDetail.goodsQuantity": "商品数量",
  "preOrderDetail.validUntil": "有效期",
  "preOrderDetail.none": "无",
  "preOrderDetail.noRecords": "暂无修改记录",
  "preOrderDetail.invite": "邀请同事协作",
  "preOrderDetail.contactMethod": "联系方式",
  "preOrderDetail.fillContact": "请填写联系方式",
  "preOrderDetail.copyLink": "点击复制链接",
  "preOrderDetail.noData": "暂无数据",
  "preOrderDetail.changeGoods": "修改商品信息",
  "preOrderDetail.price": "价格",
  "preOrderDetail.fillPrice": "请填写价格",
  "preOrderDetail.fillQuantity": "请填写数量",
  "preOrderDetail.selectDate": "请选择有效期",
  "preOrderDetail.submitChange": "提交修改",
  "preOrderDetail.chooseDate": "选择有效期",
  "preOrderDetail.usd": "美元",
  "preOrderDetail.cny": "人民币",
  "preOrderDetail.yuan": "元",
  "preOrderDetail.copySuccess": "复制成功",
  "preOrderDetail.linkCopied": "链接复制成功",
  "preOrderDetail.missingCode": "未获取到商品编号",
  "preOrderDetail.requireChange": "请至少填写价格、数量或有效期其中一项",
  "preOrderDetail.changeSuccess": "修改成功",
  "preOrderDetail.changeFailedShort": "修改失败",
  "preOrderDetail.changeFailed": "修改失败，请重试",
  "preOrderDetail.retryLater": "修改失败，请稍后重试",
  "transactionDetail.title": "订单详情",
  "transactionDetail.orderGoods": "订单商品",
  "transactionDetail.singleOrder": "单笔订单",
  "transactionDetail.mergedOrder": "合并订单",
  "transactionDetail.orderUnit": "笔",
  "transactionDetail.orderUnitOne": "笔",
  "transactionDetail.orderLabel": "订单",
  "transactionDetail.copyContractNumber": "复制合同编号",
  "transactionDetail.fastOrder": "快单",
  "transactionDetail.logisticsDetails": "物流详情",
  "transactionDetail.serviceUnavailable": "未开通",
  "transactionDetail.copyTrackingNumber": "复制物流单号",
  "transactionDetail.receiverInfo": "收货信息",
  "transactionDetail.progress": "进度",
  "transactionDetail.businessProcess": "商务流程",
  "transactionDetail.businessProcessLoading": "商务流程加载中",
  "transactionDetail.noBusinessProcess": "暂无商务流程数据",
  "transactionDetail.purchaseProcess": "采购商务流程",
  "transactionDetail.salesProcess": "销售商务流程",
  "transactionDetail.parallelNode": "并行节点：{name}",
  "transactionDetail.parallel": "并行",
  "transactionDetail.current": "当前",
  "transactionDetail.remarks": "备注",
  "transactionDetail.nodeApprovals": "节点审批 {count} 人",
  "transactionDetail.nodeApprovalDetails": "节点审批明细",
  "transactionDetail.parallelApprovalDetails": "并行节点审批明细",
  "transactionDetail.collapseProcess": "收起完整流程",
  "transactionDetail.expandProcess": "查看完整流程",
  "transactionDetail.contract": "合同",
  "transactionDetail.contractInfo": "合同信息",
  "transactionDetail.orderDetails": "订单明细",
  "transactionDetail.parties": "双方",
  "transactionDetail.attachments": "附件",
  "transactionDetail.logistics": "物流",
  "transactionDetail.afterSalesPolicy": "售后条款",
  "transactionDetail.noAfterSalesPolicy": "暂无售后条款",
  "transactionDetail.productIndex": "商品{index}",
  "transactionDetail.sellerInfo": "卖方信息",
  "transactionDetail.buyerInfo": "买方信息",
  "transactionDetail.contacts": "联系",
  "transactionDetail.attachmentIntro":
    "发票、订单票据、付款、合同及发货资料统一归档",
  "transactionDetail.fileCount": "{count} 个文件",
  "transactionDetail.attachmentCenter": "附件中心",
  "transactionDetail.attachmentCenterDescription":
    "集中查看发票、订单票据、付款、合同及发货资料",
  "transactionDetail.totalFileCount": "共 {count} 个文件",
  "transactionDetail.expand": "展开",
  "transactionDetail.collapse": "收起",
  "transactionDetail.expandContract": "展开合同",
  "transactionDetail.collapseContract": "收起合同",
  "transactionDetail.invoice": "正式发票",
  "transactionDetail.noPiFiles": "暂无 PI 文件",
  "transactionDetail.noInvoiceFiles": "暂无正式发票",
  "transactionDetail.noVatFiles": "暂无增值税发票",
  "transactionDetail.noContractFiles": "暂无交易合同",
  "transactionDetail.noOrderReceiptFiles": "暂无订单凭证",
  "transactionDetail.noPaymentProofFiles": "暂无付款凭证",
  "transactionDetail.noShippingProofFiles": "暂无发货凭证",
  "transactionDetail.noFiles": "暂无文件",
  "transactionDetail.attachment": "附件",
  "transactionDetail.preview": "预览",
  "transactionDetail.rejected": "已驳回",
  "transactionDetail.reject": "驳回",
  "transactionDetail.unknownFile": "未知文件",
  "transactionDetail.pdfFile": "PDF 文件",
  "transactionDetail.imageFile": "图片文件",
  "transactionDetail.videoFile": "视频文件",
  "transactionDetail.attachmentFile": "附件文件",
  "transactionDetail.rejectInvoice": "驳回发票",
  "transactionDetail.rejectPaymentProof": "驳回付款凭证",
  "transactionDetail.noAttachment": "暂无{label}",
  "transactionDetail.shippingCompany": "发货公司",
  "transactionDetail.trackingNumber": "物流单号",
  "transactionDetail.logisticsProgress": "物流进度",
  "transactionDetail.receiptAddress": "收货地址",
  "transactionDetail.contactPerson": "联系人",
  "transactionDetail.contactPhone": "联系电话",
  "transactionDetail.expandLogistics": "查看物流详情",
  "transactionDetail.collapseLogistics": "收起物流详情",
  "transactionDetail.viewRemarks": "查看备注",
  "transactionDetail.closeRemarks": "关闭备注弹窗",
  "transactionDetail.close": "关闭",
  "transactionDetail.reviewRejectReason": "填写复核驳回原因",
  "transactionDetail.rejectReason": "填写驳回理由",
  "transactionDetail.closeReject": "关闭驳回弹窗",
  "transactionDetail.confirmSubmit": "确认提交",
  "transactionDetail.tradeOrders": "交易订单中心",
  "transactionDetail.viewDetails": "查看详情",
  "transactionDetail.contractNumber": "合同编号",
  "transactionDetail.deliveryDate": "交货日期",
  "transactionDetail.orderType": "订单类型",
  "transactionDetail.trade": "贸易",
  "transactionDetail.supplyChain": "供应链",
  "transactionDetail.factoring": "保理放账",
  "transactionDetail.totalPrice": "综合总价",
  "transactionDetail.commission": "综合佣金",
  "transactionDetail.quantity": "数量",
  "transactionDetail.orderIndex": "订单{index}",
  "transactionDetail.orderInfo": "订单信息",
  "transactionDetail.orderNumber": "订单编号",
  "transactionDetail.productName": "产品名称",
  "transactionDetail.productBrand": "产品品牌",
  "transactionDetail.partNumber": "产品料号",
  "transactionDetail.deliveryRegion": "交货地区",
  "transactionDetail.unitPrice": "产品单价",
  "transactionDetail.productQuantity": "产品数量",
  "transactionDetail.productTotal": "产品总价",
  "transactionDetail.sellerCompany": "卖家信息",
  "transactionDetail.buyerCompany": "买家信息",
  "transactionDetail.companyName": "公司名称",
  "transactionDetail.companyEnglishName": "公司名称(英)",
  "transactionDetail.taxNumber": "公司税号",
  "transactionDetail.registrationNumber": "商业登记号",
  "transactionDetail.primaryContact": "主联系人",
  "transactionDetail.companyAddress": "公司地址",
  "transactionDetail.bank": "开户银行",
  "transactionDetail.bankEnglishName": "银行英名",
  "transactionDetail.bankAccount": "银行账号",
  "transactionDetail.receivingAccount": "收款账号",
  "transactionDetail.recipient": "收货人",
  "transactionDetail.recipientPhone": "收货电话",
  "transactionDetail.placeOrderInfo": "下单信息",
  "transactionDetail.originalPrice": "商品原价",
  "transactionDetail.offerPrice": "意向价格",
  "transactionDetail.approx": "约",
  "transactionDetail.originCertificate": "原产地证明",
  "transactionDetail.inviteSellerLink": "邀请货主链接",
  "transactionDetail.agentService": "订单客服",
  "transactionDetail.purchaseBusiness": "采购商务",
  "transactionDetail.salesBusiness": "销售商务",
  "transactionDetail.purchaseContacts": "采购联系人",
  "transactionDetail.salesContacts": "销售联系人",
  "transactionDetail.platformContacts": "平台联系人",
  "transactionDetail.proformaInvoice": "形式发票",
  "transactionDetail.orderReceipt": "订单凭证",
  "transactionDetail.vatInvoice": "增值税发票",
  "transactionDetail.paymentProof": "付款凭证",
  "transactionDetail.shippingProof": "发货凭证",
  "transactionDetail.tradeContract": "交易合同",
  "transactionDetail.pickedUp": "已揽收",
  "transactionDetail.pickedUpDesc": "快件已被揽收点接收",
  "transactionDetail.inTransit": "运输中",
  "transactionDetail.inTransitDesc": "快件正在运输途中",
  "transactionDetail.outForDelivery": "派送中",
  "transactionDetail.outForDeliveryDesc": "快件正在派送中，请保持电话畅通",
  "transactionDetail.delivered": "已签收",
  "transactionDetail.deliveredDesc": "快件已被本人签收",
  "transactionDetail.reviewConfirm": "复核确认",
  "transactionDetail.reviewQuestion": "确认该{target}复核通过吗？",
  "transactionDetail.approve": "确认通过",
  "transactionDetail.cancel": "取消",
  "transactionDetail.rejectSuccess": "驳回成功",
  "transactionDetail.rejectFailed": "驳回失败，请重试",
  "transactionDetail.noContractId": "合同ID为空，无法提交复核",
  "transactionDetail.reviewFailed": "复核失败，请重试",
  "transactionDetail.reviewApproved": "复核通过",
  "transactionDetail.reviewRejected": "复核驳回成功",
  "transactionDetail.copySuccess": "复制成功",
  "transactionDetail.copyFailed": "复制失败",
  "transactionDetail.previewFailed": "附件预览失败",
  "transactionDetail.authFailed": "授权失败",
  "transactionDetail.loadFailed": "订单详情加载失败",
  "transactionDetail.afterSaleApplication": "填写售后申请",
  "transactionDetail.transactionNumber": "交易编号",
  "transactionDetail.afterSaleType": "售后类型",
  "transactionDetail.selectType": "请选择类型",
  "transactionDetail.afterSaleReason": "售后原因",
  "transactionDetail.selectReason": "请选择原因",
  "transactionDetail.description": "详细描述",
  "transactionDetail.fillDescription": "请填写详细描述",
  "transactionDetail.imageProof": "图片凭证",
  "transactionDetail.imageHelp":
    "支持 jpg/jpeg/png 格式，最多 9 张，建议上传产品实拍图、包装图等",
  "transactionDetail.videoProof": "视频凭证",
  "transactionDetail.uploadVideo": "上传视频凭证",
  "transactionDetail.videoHelp":
    "支持 mp4/avi 格式，最多 3 个，建议上传功能演示/故障视频",
  "transactionDetail.submitApplication": "提交申请",
  "transactionDetail.reset": "重置",
  "transactionDetail.refundOnly": "仅退款",
  "transactionDetail.returnAndRefund": "退货退款",
  "transactionDetail.exchange": "换货",
  "transactionDetail.factoryRepair": "返厂维修",
  "transactionDetail.partMismatch": "芯片料号与描述不符",
  "transactionDetail.qualityIssue": "产品存在质量问题",
  "transactionDetail.shortQuantity": "数量不足",
  "transactionDetail.differentPart": "需要更换其他料号",
  "transactionDetail.suspectedFake": "疑似假货",
  "transactionDetail.other": "其他",
  "transactionDetail.missingAuthCode": "授权参数缺失，请重新授权",
  "transactionDetail.loginSuccess": "登录成功",
  "transactionDetail.requestError": "请求异常！",
  "transactionDetail.missingOrderId": "订单ID为空",
  "transactionDetail.selectTransaction": "请选择交易编号",
  "transactionDetail.selectAfterSaleType": "请选择售后类型",
  "transactionDetail.selectAfterSaleReason": "请选择售后原因",
  "transactionDetail.uploadImageProof": "请上传图片凭证",
  "transactionDetail.submitFailed": "提交失败，请重试",
  "transactionDetail.sellerRole": "货主",
  "transactionDetail.businessRole": "商务",
  "transactionDetail.negotiatorRole": "谈判人",
  "transactionDetail.buyerRole": "买家",
});

// 桌面购物车
export const desktopCart = Object.freeze({
  "pcCart.cartTitle": "采购清单",
  "pcCart.productCount": "共 {count} 件商品",
  "pcCart.searchPlaceholder": "搜索商品料号、名称",
  "pcCart.selectAll": "全选",
  "pcCart.deleteSelected": "删除已选",
  "pcCart.moveToFavorites": "移入收藏",
  "pcCart.selectedProducts": "已选择 {count} 件商品",
  "pcCart.partNumber": "料号",
  "pcCart.stock": "库存",
  "pcCart.pieces": "{count} 件",
  "pcCart.approx": "约",
  "pcCart.subtotal": "小计",
  "pcCart.deleteProduct": "删除商品",
  "pcCart.emptyTitle": "采购清单为空",
  "pcCart.emptyDescription": "您的采购清单还没有任何商品",
  "pcCart.shopNow": "去采购",
  "pcCart.orderSummary": "订单摘要",
  "pcCart.selectedItems": "已选商品",
  "pcCart.totalItems": "商品总数",
  "pcCart.usdItemsTotal": "美元商品合计",
  "pcCart.cnyItemsTotal": "人民币商品合计",
  "pcCart.total": "合计",
  "pcCart.overallTotal": "综合总价",
  "pcCart.submitIntent": "提交采购意向",
  "pcCart.pendingConfirmation": "共 {count} 件商品待确认",
  "pcCart.priceFluctuation": "商品价格随市场波动",
  "pcCart.paymentMethods": "支持多种支付方式",
  "pcCart.selectedPreview": "已选商品预览",
  "pcCart.selectFavoriteFirst": "请先选择要收藏的商品",
  "pcCart.favoriteSuccess": "收藏成功",
  "pcCart.selectDeleteFirst": "请先选择要删除的商品",
  "pcCart.confirmDeleteSelected": "确定要删除选中的商品吗？",
  "pcCart.confirmDeleteProduct": "确定要删除该商品吗？",
  "pcCart.notice": "提示",
  "pcCart.confirm": "确定",
  "pcCart.cancel": "取消",
  "pcCart.deleteSuccess": "删除成功",
  "pcCart.selectProductFirst": "请先选择商品",
  "pcCart.multiCurrencyWarning":
    "已选中多个币种的商品，如果下单会拆分成多个订单，请确定是否继续下单",
  "pcCart.backToCart": "返回采购清单",
  "pcCart.orderProducts": "下单商品",
  "pcCart.productImage": "商品图片",
  "pcCart.unnamedProduct": "未命名商品",
  "pcCart.model": "型号：",
  "pcCart.quantity": "数量：",
  "pcCart.unitPiece": "件",
  "pcCart.noSelectedProducts": "暂无已选商品",
  "pcCart.productsTotal": "商品合计",
  "pcCart.exchangeDisclaimer": "以当前汇率折算，仅供参考",
  "pcCart.buyerInfo": "买家信息",
  "pcCart.buyerInfoHint": "用于生成采购意向单",
  "pcCart.companyName": "公司名称",
  "pcCart.companyPlaceholder": "请填写公司名称",
  "pcCart.taxNumber": "税号",
  "pcCart.taxPlaceholder": "请填写税号",
  "pcCart.contact": "联系人",
  "pcCart.contactPlaceholder": "请填写联系人",
  "pcCart.contactDetails": "联系方式",
  "pcCart.contactDetailsPlaceholder": "请填写联系方式",
  "pcCart.deliveryAddress": "交货地址",
  "pcCart.deliveryAddressPlaceholder": "请填写交货地址",
  "pcCart.uploadOrderInfo": "上传订单信息",
  "pcCart.uploadHint": "支持上传合同、采购单或其他订单资料，最多 10 个文件",
  "pcCart.uploadFile": "上传文件",
  "pcCart.productDetails": "{name}资料",
  "pcCart.productNumber": "商品 {count}",
  "pcCart.contactPhone": "联系电话",
  "pcCart.submitting": "正在提交",
  "pcCart.submitPurchaseIntent": "提交采购意向单",
  "pcCart.loginFirst": "请先登录",
  "pcCart.submitSuccess": "采购意向单提交成功！",
});

// 合同审核
export const contractReview = Object.freeze({
  "contractReview.back": "返回",
  "contractReview.salesOrderInfo": "销售订单信息",
  "contractReview.salesOrderDescription": "核对商品、订单与销售合同明细",
  "contractReview.purchaseOrderInfo": "采购订单信息",
  "contractReview.purchaseOrderDescription": "核对商品、合同与采购明细",
  "contractReview.productInfo": "商品信息",
  "contractReview.contractInfo": "合同信息",
  "contractReview.inviteSeller": "邀请货主绑定商品",
  "contractReview.productProvider": "商品提供人",
  "contractReview.noTerms": "无",
  "contractReview.productIndex": "商品{index}",
  "contractReview.contractNumberPlaceholder": "请输入合同编号",
  "contractReview.copySuccess": "复制成功",
  "contractReview.copyFailed": "复制失败",
  "contractReview.sellerInfo": "卖方信息",
  "contractReview.buyerInfo": "买方信息",
  "contractReview.sellerPaymentInfo": "卖方收款资料",
  "contractReview.moreSellerInfo": "更多卖方资料",
  "contractReview.moreBuyerInfo": "更多买方资料",
  "contractReview.moreBuyerPaymentInfo": "更多买家资料",
  "contractReview.newContact": "新建联系人",
  "contractReview.changeContact": "更换联系人",
  "contractReview.addBank": "新增银行",
  "contractReview.changeBank": "更换银行",
  "contractReview.clear": "清空",
  "contractReview.fillRemarks": "请填写备注",
  "contractReview.attachment": "附件",
  "contractReview.uploadAttachment": "上传附件",
  "contractReview.requiredField": "{party}{field}不能为空",
  "contractReview.seller": "卖方",
  "contractReview.buyer": "买方",
  "contractReview.contactAdded": "联系人添加成功",
  "contractReview.contactChanged": "联系人更换成功",
  "contractReview.productName": "产品名称",
  "contractReview.partNumber": "产品料号",
  "contractReview.productQuantity": "产品数量",
  "contractReview.unitPrice": "产品单价",
  "contractReview.productTotal": "产品总价",
  "contractReview.brand": "品牌",
  "contractReview.productNumber": "商品编号",
  "contractReview.orderNumber": "订单编号",
  "contractReview.deliveryRegion": "交货地区",
  "contractReview.dateCode": "批次（DC）",
  "contractReview.goodsCondition": "货物情况",
  "contractReview.deliveryDate": "交货日期",
  "contractReview.orderType": "订单类型",
  "contractReview.afterSalesTerms": "售后条款",
  "contractReview.orderRemarks": "订单备注",
  "contractReview.contractNumber": "合同编号",
  "contractReview.grandTotal": "综合总价",
  "contractReview.paymentMethod": "付款方式",
  "contractReview.companyName": "公司名称",
  "contractReview.companyNameZh": "公司名称(中)",
  "contractReview.companyNameEn": "公司名称(英)",
  "contractReview.accountName": "账户名称",
  "contractReview.contact": "联系人",
  "contractReview.primaryContact": "主联系人",
  "contractReview.contactPhone": "联系电话",
  "contractReview.phone": "电话",
  "contractReview.remarks": "备注",
  "contractReview.companyAddress": "公司地址",
  "contractReview.taxNumber": "公司税号",
  "contractReview.registrationNumber": "商业登记号",
  "contractReview.bankNameEn": "银行英名",
  "contractReview.bankNameZh": "银行中名",
  "contractReview.bank": "开户银行",
  "contractReview.bankAccount": "银行账号",
  "contractReview.bankAddressZh": "银行地址（中）",
  "contractReview.bankAddressEn": "银行地址（英）",
  "contractReview.bankBranch": "开户支行",
  "contractReview.bankBranchCode": "联行号",
  "contractReview.receivingAccount": "收款账号",
  "contractReview.shippingAddress": "收货地址",
  "contractReview.recipient": "收货人",
  "contractReview.recipientPhone": "收货电话",
  "contractReview.salesTotal": "销售总价",
  "contractReview.purchaseTotal": "采购总价",
  "contractReview.profit": "利润统计",
  "contractReview.orderImages": "订单信息图片",
  "contractReview.noAttachments": "暂无附件",
  "contractReview.tradeContract": "交易合同",
  "contractReview.customerUploadsSingle": "由客户上传单章合同文件",
  "contractReview.uploadTradeContract": "上传交易合同",
  "contractReview.viewTradeContract": "查看交易合同",
  "contractReview.confirmUpload": "确定上传",
  "contractReview.uploadTemplate": "上传合同模板",
  "contractReview.contractTemplate": "合同模板",
  "contractReview.uploadSingle": "上传单章合同",
  "contractReview.singleContract": "单章合同",
  "contractReview.uploadDual": "上传双章合同",
  "contractReview.dualContract": "双章合同",
  "contractReview.approvalAttachmentsHint": "上传审批所需发票及其他附件",
  "contractReview.otherAttachments": "其他附件",
  "contractReview.contractRemarks": "合同备注",
  "contractReview.fillContractRemarks": "请填写合同备注",
  "contractReview.noRemarks": "暂无备注",
  "contractReview.buyerAttachments": "买方附件",
  "contractReview.myAttachments": "我的附件",
  "contractReview.purchaseSellerInfo": "采购卖方信息",
  "contractReview.purchaseBuyerInfo": "采购买方信息",
  "contractReview.reject": "驳回",
  "contractReview.relatedOrderHint":
    "选择需要关联到当前销售订单的历史订单、合同或付款审核记录",
  "contractReview.rejectReason": "填写驳回理由",
  "contractReview.confirmSubmit": "确认提交",
  "contractReview.addCc": "添加抄送人",
  "contractReview.addCcHint": "搜索并选择需要同步本次销售订单进度的人员",
  "contractReview.searchCc": "搜索抄送人",
  "contractReview.cc": "抄送人",
  "contractReview.contractPreview": "合同预览",
  "contractReview.initiateApproval": "发起合同审批",
  "contractReview.reviewSalesContract": "审核销售合同",
  "contractReview.viewSalesContract": "查看销售合同",
  "contractReview.reviewSalesOrder": "审核销售订单",
  "contractReview.viewSalesOrder": "查看销售订单",
  "contractReview.confirmTradeContract": "确认交易合同",
  "contractReview.approveReview": "审核通过",
  "contractReview.confirmTemplate": "确认合同模板",
  "contractReview.confirmSalesOrder": "确认销售订单",
  "contractReview.trade": "贸易",
  "contractReview.supplyChain": "供应链",
  "contractReview.factoring": "保理放账",
  "contractReview.payBeforeDelivery": "先款后货",
  "contractReview.payAfterDelivery": "先货后款",
  "contractReview.notStarted": "待发起",
  "contractReview.underReview": "审核中",
  "contractReview.approved": "已通过",
  "contractReview.rejected": "已驳回",
  "contractReview.unknown": "未知",
  "contractReview.reviewRemarks": "审核备注",
  "contractReview.fillReviewerRemarks": "请填写审核人备注",
});

// 跟单
export const follow = Object.freeze({
  "pcFollow.searchPlaceholder": "搜索商品名称、料号、品牌、类型、数量",
  "pcFollow.loginRequired": "请先登录！",
  "pcFollow.notNegotiator": "你不是谈判人，请申请成为谈判人",
  "pcFollow.underReview": "审核中",
  "pcFollow.applyNegotiator": "申请成为谈判人",
  "pcFollow.businessTracking": "商务跟单页",
  "pcFollow.negotiatorTracking": "谈判人跟单页",
  "pcFollow.buyer": "买家",
  "pcFollow.seller": "货主",
  "pcFollow.reviewInProgress": "正在审核中",
  "pcFollow.titleWithRole": "{role}{title}",
});

// 桌面订单组件
export const desktopComponents = Object.freeze({
  "pcOrder.merged": "合并",
  "pcOrder.contractNumber": "合同编号：",
  "pcOrder.orderNumber": "订单编号：",
  "pcOrder.productNumber": "商品编号：",
  "pcOrder.split": "拆分",
  "pcOrder.revoke": "撤回",
  "pcOrder.inviteSellerLink": "邀请货主链接",
  "pcOrder.splitOrder": "拆单",
  "pcOrder.fastOrder": "快单",
  "pcOrder.personLabelSeparator": "：",
  "pcOrder.buyerRole": "买家",
  "pcOrder.sellerRole": "货主",
  "pcOrder.salesNegotiatorRole": "销售谈判人",
  "pcOrder.salesBusinessRole": "销售商务",
  "pcOrder.purchaseNegotiatorRole": "采购谈判人",
  "pcOrder.purchaseBusinessRole": "采购商务",
  "pcOrder.supervisorRole": "监督人",
  "pcOrder.inspectorRole": "验货人",
  "pcOrder.uploadTradeContract": "上传交易合同",
  "pcOrder.uploadSingleStampContract": "上传单章合同",
  "pcOrder.uploadDualStampContract": "上传双章合同",
  "pcOrder.editTradeContract": "修改交易合同",
  "pcOrder.initiateContractReview": "发起合同审批",
  "pcOrder.initiateTemplateReview": "发起合同模板审批",
  "pcOrder.viewTradeContract": "查看交易合同",
  "pcOrder.viewPaymentProof": "查看付款凭证",
  "pcOrder.viewContractTemplate": "查看合同模板",
  "pcOrder.confirmTradeContract": "确认交易合同",
  "pcOrder.confirmContractTemplate": "确认合同模板",
  "pcOrder.productPublished": "产品发布",
  "pcOrder.platformListed": "平台展示",
  "pcOrder.brand": "品牌",
  "pcOrder.name": "名称",
  "pcOrder.quantity": "数量",
  "pcOrder.originalQuantity": "拆分前数量",
  "pcOrder.unitPrice": "单价",
  "pcOrder.viewDetails": "查看详情",
  "pcOrder.withdrawOrder": "撤回订单",
  "pcOrder.generateSalesOrder": "生成销售订单",
  "pcOrder.generatePurchaseOrder": "生成采购订单",
  "pcOrder.inspect": "验货",
  "pcOrder.inspectionDetails": "验货详情",
  "pcOrder.reviewNow": "去评价",
  "pcOrder.viewReview": "查看评价",
  "pcOrder.uploadInvoice": "上传发票",
  "pcOrder.confirmPayment": "确认收款",
  "pcOrder.uploadShipping": "上传物流信息",
  "pcOrder.uploadPaymentProof": "上传付款凭证",
  "pcOrder.confirmReceipt": "确认收货",
  "pcOrder.purchaseProduct": "采购商品",
  "pcOrder.salesProduct": "销售商品",
  "pcOrder.onlyBuyerMayWithdraw": "仅订单买家本人可以撤回订单",
  "pcOrder.orderIdUnavailable": "未获取到订单ID",
  "pcOrder.withdrawWarning": "撤回后需要重新下单，确认撤回该订单吗？",
  "pcOrder.notice": "提示",
  "pcOrder.confirmWithdraw": "确认撤回",
  "pcOrder.cancel": "取消",
  "pcOrder.withdrawSuccess": "撤回成功",
  "pcOrder.revokeSplitWarning": "确认撤回已拆分的订单？",
  "pcOrder.copySuccess": "复制成功",
  "pcOrder.copyFailed": "复制失败",
  "pcOrder.paymentProofRequired": "请上传付款凭证！",
  "pcOrder.paymentProofUploaded": "上传付款凭证成功！",
  "pcOrder.proofOrNoteRequired": "请上传凭证或备注！",
  "pcOrder.shippingUploaded": "上传物流信息成功！",
  "pcOrder.receiptConfirmed": "确认收货成功！",
  "pcOrder.paymentConfirmed": "确认收款成功！",
  "pcOrder.invoiceRequired": "请至少上传一份发票！",
  "pcOrder.invoiceUploaded": "上传发票成功！",
  "pcOrder.splitDialogTitle": "拆分订单",
  "pcOrder.splitDialogHint": "选择拆分单数，并分配每单数量",
  "pcOrder.totalProducts": "商品总数",
  "pcOrder.productUnitPrice": "商品单价",
  "pcOrder.splitInto": "拆分为",
  "pcOrder.splitEvenlyHint": "系统将自动平均分配，可按需微调",
  "pcOrder.orderUnit": "单",
  "pcOrder.quantityPerOrder": "每单数量",
  "pcOrder.fullyAllocated": "已分配完",
  "pcOrder.remaining": "剩余 {count}",
  "pcOrder.orderNumbered": "订单 {count}",
  "pcOrder.confirmSplit": "确认拆分",
  "pcOrder.invalidSplitQuantity":
    "拆单数量不能少于2，且每单分配数量之和必须等于商品总数！",
  "pcOrder.splitSuccess": "拆分成功",
  "pcOrder.splitFailed": "拆分失败",
});

// 桌面交易订单
export const desktopTransactions = Object.freeze({
  "pcTransaction.title": "交易订单中心",
  "pcTransaction.pendingAction": "待处理",
  "pcTransaction.allOrders": "全部订单",
  "pcTransaction.purchaseOrders": "采购订单",
  "pcTransaction.salesOrders": "销售订单",
  "pcTransaction.intentions": "意向列表",
  "pcTransaction.searchAll": "全部搜索",
  "pcTransaction.searchName": "名称搜索",
  "pcTransaction.searchPartNumber": "料号搜索",
  "pcTransaction.searchPlaceholder": "{field}搜索",
  "pcTransaction.name": "名称",
  "pcTransaction.partNumberShort": "料号",
  "pcTransaction.nameAndPartNumber": "名称、料号",
  "pcTransaction.inviteCollaboration": "邀请协作",
  "pcTransaction.orderingCompany": "下单公司",
  "pcTransaction.supplier": "供应商",
  "pcTransaction.productName": "货物名称",
  "pcTransaction.partNumber": "规格型号（料号）",
  "pcTransaction.startDate": "订单开始日期",
  "pcTransaction.to": "至",
  "pcTransaction.endDate": "订单结束日期",
  "pcTransaction.search": "搜索",
  "pcTransaction.exportReport": "导出报表",
  "pcTransaction.loading": "加载中...",
  "pcTransaction.noMore": "没有更多了",
  "pcTransaction.backToTop": "回到顶部",
  "pcTransaction.pendingFollows": "您现在有{count}个跟单",
  "pcTransaction.pendingOrders": "您现在有{count}个订单",
  "pcTransaction.noIntentionOrders": "暂无意向订单数据",
  "pcTransaction.noOrders": "暂无订单数据",
  "pcTransaction.exportFailed": "报表导出失败",
  "pcTransaction.salesPaymentReport": "销售付款报表",
  "pcTransaction.purchasePaymentReport": "采购付款报表",
  "pcTransaction.summaryReport": "交易汇总报表",
  "pcTransaction.allDates": "全部",
  "pcTransaction.exportSuccess": "报表导出成功",
});

// 个人订单
export const personal = Object.freeze({
  "personalOrderList.buyerTitle": "我是买家",
  "personalOrderList.saleTitle": "我的销售订单",
  "personalOrderList.followTitle": "我的跟单订单",
  "personalOrderList.noMore": "我们是有底线的",
  "personalOrderList.noData": "暂无数据",
  "personalOrderList.imageLoading": "图片加载中",
  "personalOrderList.supplyInfo": "货源信息",
  "personalOrderList.unitPrice": "单价",
  "personalOrderList.quantity": "数量",
  "personalOrderList.viewDetails": "查看详情",
  "personalOrderList.completeInfo": "资料完善",
  "personalOrderList.image": "图片",
  "personalOrderList.title": "标题",
  "personalOrderList.brand": "品牌",
  "personalOrderList.time": "时间",
  "personalOrderList.action": "操作",
  "personalOrderList.all": "全部",
  "personalOrderList.pendingConfirmation": "待确认",
  "personalOrderList.pendingCommission": "待付佣金",
  "personalOrderList.transactionComplete": "交易完成",
  "personalOrderList.pendingReview": "待评价",
  "personalOrderList.reviewed": "已评价",
  "personalOrderList.supply": "货源",
  "personalOrderList.buyRequest": "求购",
  "contractList.title": "我的合同记录",
  "contractList.auditStatus": "审核状态",
  "contractList.selectStatus": "请选择状态",
  "contractList.contractNumber": "合同编号",
  "contractList.pending": "待审核",
  "contractList.approved": "已通过",
  "contractList.rejected": "已驳回",
  "contractList.all": "全部",
  "contractList.remark": "备注",
  "contractList.createdAt": "创建时间",
  "contractList.action": "操作",
  "contractList.viewDetails": "查看详情",
  "orderDetail.title": "订单详情",
  "orderDetail.status": "订单状态",
  "orderDetail.commissionInfo": "佣金信息",
  "orderDetail.commissionAmount": "佣金金额",
  "orderDetail.paymentStatus": "支付状态",
  "orderDetail.unpaid": "待支付",
  "orderDetail.paid": "已支付",
  "orderDetail.paymentTime": "支付时间",
  "orderDetail.orderInfo": "订单信息",
  "orderDetail.orderNumber": "订单号",
  "orderDetail.orderTime": "下单时间",
  "orderDetail.goodsAmount": "商品总金额",
  "orderDetail.orderAmount": "订单金额",
  "orderDetail.buyer": "买家",
  "orderDetail.buyerCompany": "买家中间公司",
  "orderDetail.seller": "货主",
  "orderDetail.sellerCompany": "货主中间公司",
  "orderDetail.payCommission": "去支付佣金",
  "orderDetail.uploadPaymentProof": "上传支付凭证",
  "orderDetail.confirmReceipt": "确认收货",
  "orderDetail.commissionPayment": "佣金支付",
  "orderDetail.payNow": "立即支付￥{amount}",
  "orderDetail.paymentProof": "支付凭证",
  "orderDetail.paymentEvidence": "支付凭据",
  "orderDetail.submit": "提交",
  "orderDetail.confirmPayment": "确认收款",
  "orderDetail.shippingCompany": "发货公司",
  "orderDetail.trackingNumber": "物流单号",
  "orderDetail.shippingProof": "发货凭证",
  "orderDetail.uploadShippingProof": "上传发货凭证",
  "orderDetail.shippingInfo": "上传发货信息",
  "orderDetail.ship": "发货",
  "orderDetail.goShip": "去发货",
  "orderDetail.invoiceInfo": "上传发票信息",
  "orderDetail.invoiceProof": "发票凭证",
  "orderDetail.uploadInvoiceProof": "上传发票凭证",
  "orderDetail.required": "必填项",
  "orderDetail.validNumber": "请输入有效的数字",
  "orderDetail.paymentSuccess": "支付成功！",
  "orderDetail.uploadSuccess": "上传成功！",
  "orderDetail.receiptSuccess": "完成收货！",
  "orderDetail.confirmSuccess": "确认成功！",
  "orderDetail.shipSuccess": "发货成功！",
  "orderDetail.wechatQrAlt": "微信支付二维码",
  "orderDetail.loading": "加载中...",
});

// 拆单
export const split = Object.freeze({
  "splitOrder.title": "拆分订单",
  "splitOrder.close": "关闭拆分订单弹窗",
  "splitOrder.yuan": "元",
  "splitOrder.totalQuantity": "总数：",
  "splitOrder.splitInto": "订单拆分成",
  "splitOrder.orderCount": "拆分后的订单数量",
  "splitOrder.ordersUnit": "单",
  "splitOrder.orderLabel": "订单{label}：",
  "splitOrder.splitQuantity": "拆分数量",
  "splitOrder.remaining": "剩余可分：{count}",
  "splitOrder.confirm": "确认拆分",
  "splitOrder.unallocatedQuantity": "还有剩余数量未拆分完！",
  "splitOrder.success": "拆分成功",
  "splitOrder.failed": "拆分失败",
});

// 出库单列表：状态、仓库及接口错误仅作显示翻译，不改业务值。
export const outboundList = Object.freeze({
  "outboundList.title": "出库单列表",
  "outboundList.status": "出库单状态",
  "outboundList.allStatuses": "全部状态",
  "outboundList.allWarehouses": "全部仓库",
  "outboundList.startDate": "开始日期",
  "outboundList.endDate": "结束日期",
  "outboundList.rangeSeparator": "至",
  "outboundList.dispatchStartDate": "出库开始日期",
  "outboundList.dispatchEndDate": "出库结束日期",
  "outboundList.add": "添加出库单",
  "outboundList.total": "共 {count} 条",
  "outboundList.empty": "暂无出库单数据",
  "outboundList.pending": "待审批",
  "outboundList.inReview": "审批中",
  "outboundList.approved": "审批通过",
  "outboundList.rejected": "审批驳回",
  "outboundList.warehouseHengda": "香港恒达",
  "outboundList.warehouseHualian": "香港华联",
  "outboundList.warehouseShenzhen": "深圳",
  "outboundList.review": "审核出库单",
  "outboundList.view": "查看出库单",
  "outboundList.details": "查看详情",
  "outboundList.rejectionReason": "驳回原因",
  "outboundList.invalidId": "出库单ID无效，请刷新列表",
  "outboundList.loadFailed": "出库单列表加载失败，请重试",
  "outboundList.dateOrderError": "出库开始日期不能晚于结束日期",
  "outboundList.queryRequired": "查询参数不能为空",
  "outboundList.invalidStatus": "审批状态必须为0至3",
  "outboundList.invalidPage": "页码必须大于0",
  "outboundList.invalidPageSize": "每页条数必须在1到100之间",
  "outboundList.forbidden": "无权操作出库单",
  "outboundList.unavailable": "出库操作失败，请稍后重试",
});

// 采购／销售订单生成与关联内容：三语仅作用于显示，不改选项、审批状态及原始正文。
export const contractFlow = Object.freeze({
  "contractFlow.bankAttachments": "银行附件",
  "contractFlow.purchaseTitle": "采购商务生成采购订单",
  "contractFlow.salesTitle": "销售商务生成销售订单",
  "contractFlow.purchaseIntro": "填写采购订单信息，确认交易主体与审核流程",
  "contractFlow.salesIntro": "填写销售订单信息，确认交易主体与审核流程",
  "contractFlow.purchaseOnBehalf": "代采代付",
  "contractFlow.purchaseWithAdvance": "代采垫付",
  "contractFlow.factoryPackaging": "原厂原包",
  "contractFlow.nonFactoryPackaging": "非原厂原包",
  "contractFlow.selfPackagedChips": "自封颗粒",
  "contractFlow.testedOriginalMarking": "原标（测试）",
  "contractFlow.nonOriginalMarking": "非原标",
  "contractFlow.refurbished": "翻新",
  "contractFlow.used": "二手",
  "contractFlow.salesContract": "销售合同",
  "contractFlow.purchaseContract": "采购合同",
  "contractFlow.paymentReview": "付款审核",
  "contractFlow.order": "订单",
  "contractFlow.payment": "付款",
  "contractFlow.relatedSearchPlaceholder":
    "搜索关联订单的订单编号、标题、内容等",
  "contractFlow.relatedNotFound": "未找到关联内容",
  "contractFlow.relatedUnavailable": "暂无可关联内容",
  "contractFlow.selectedCount": "已选 {count} 项",
  "contractFlow.noDetails": "暂无详细信息",
  "contractFlow.missingDetails": "暂无{type}详情数据",
  "contractFlow.relatedLoadFailed": "关联内容加载失败",
  "contractFlow.expandRelated": "展开关联内容",
  "contractFlow.collapseRelated": "收起关联内容",
  "contractFlow.deleteRelated": "删除关联内容",
  "contractFlow.selectRelatedOrder": "选择关联订单",
  "contractFlow.deselectRelatedOrder": "取消选择关联订单",
  "contractFlow.purchaseRelatedHint":
    "选择需要关联到当前采购订单的历史订单、合同或付款审核记录",
  "contractFlow.salesRelatedHint":
    "选择需要关联到当前销售订单的历史订单、合同或付款审核记录",
  "contractFlow.paymentRelatedHint":
    "选择需要关联到当前付款审批的历史订单、合同或付款审核记录",
  "contractFlow.purchaseCcHint": "搜索并选择需要同步本次采购订单进度的人员",
  "contractFlow.salesCcHint": "搜索并选择需要同步本次销售订单进度的人员",
});

// 手机端业务流程：三语只改变固定界面文案。
export const mobileWorkflow = Object.freeze({
  "orderForm.productPrice": "商品{number}价格",
  "orderForm.enterRegistrationNumber": "请填写商业登记号",
  "orderForm.removeProduct": "删除商品{number}",
  "orderForm.taxNumber": "税号：{number}",
  "orderForm.personInCharge": "负责人：{name}",
  "orderForm.cannotDeselect": "当前订单不能取消选择",
  "inspection.deselect": "取消选择",
  "contractReview.noFixedFlow": "暂未获取到固定审核流程",
  "preOrder.buy": "购买",
  "preOrder.sell": "出售",
  "contractReview.purchaseReviewTitle": "审核采购合同",
  "contractReview.approvalInformation": "审批信息",
  "contractReview.downloadFailed": "下载失败",
  "contractReview.ccAlreadyAdded": "该抄送人已添加",
  "invoiceApproval.initiate": "发起INV审批",
  "invoiceApproval.review": "审核INV",
  "invoiceApproval.confirm": "确认INV审核通过？",
  "orderForm.nonNegative": "请输入大于或等于 0 的数值",
  "orderForm.selectBuyerCompany": "请选择买方公司",
  "contractReview.draftFailed": "获取合同草稿失败",
  "orderFollow.businessTracking": "商务跟单",
  "orderFollow.hideConfirm": "确定屏蔽该条信息吗？",
  "orderFollow.hidden": "屏蔽成功",
  "orderFollow.businessAcceptance": "商务接单",
  "preOrder.edit": "修改购买意向单",
  "preOrder.updatedAwaitingPurchase": "修改确认成功！等待采购谈判人确认！",
  "orderFollow.negotiatorAcceptance": "谈判人接单",
  "orderFollow.hideLeadConfirm": "确定屏蔽该条线索吗？",
  "preOrder.confirmPurchase": "确认购买意向单",
  "preOrder.purchaseTracking": "采购谈判人-跟单详情",
  "preOrder.salesTracking": "销售谈判人-跟单详情",
  "inspection.outerPackaging": "外包装",
  "inspection.middlePackaging": "中包装",
  "inspection.minimumPackaging": "最小包装",
  "inspection.productDetails": "产品细节",
  "inspection.confirmDelete": "确认删除",
  "inspection.completeConfirm": "确认后将完成本次验货，是否继续？",
  "inspection.submitConfirm": "确认后将提交本次验货结果，是否继续？",
  "contractRoles.initiator": "发起人",
  "contractRoles.selfReview": "自审",
  "contractRoles.businessManager": "商务经理",
  "contractRoles.businessDirector": "业务总监",
  "contractRoles.generalManager": "总经理",
  "contractRoles.negotiatorManager": "谈判人领导",
  "contractReview.reviewAndCc": "审核与抄送",
  "contractReview.noReviewers": "暂无审核人",
  "contractReview.loadingCc": "正在加载默认抄送人",
  "contractReview.reviewLevel": "第{level}级审核",
  "contractReview.removeReviewer": "删除{role}：{name}",
  "contractReview.keepReviewer": "至少保留一个审核节点",
  "contractReview.deleteReviewer": "删除审核人",
  "contractReview.removeCc": "移除{name}",
  "purchasePayment.noApprovalFlow": "暂未获取到付款审批流程",
  "purchasePayment.reviewerRemarkHint":
    "请填写审核人备注（填写本次付款审核处理意见）",
  "orderFollow.confirmMerge": "确认合并",
  "orderFollow.noAvailableOrders": "还没有单可抢, 先等等吧",
  "preOrder.enterPrice": "请填写意向价格",
  "preOrder.quantity": "意向数量",
  "preOrder.buyerCommissionRate": "买家佣金比例",
  "preOrder.sellerCommissionRate": "货主佣金比例",
  "preOrder.enterCommissionRate": "请填写佣金比例",
  "preOrder.estimatedPayment": "需支付约",
  "preOrder.usdSuffix": "美元;",
  "preOrder.cnySuffix": "人民币;",
  "preOrder.tradeNotes": "交易信息备注",
  "preOrder.enterTradeNotes": "请输入交易信息备注",
  "preOrder.sellerContacts": "货主联系信息",
  "preOrder.buyerContacts": "买家联系信息",
  "preOrder.buyerPrefix": "买主-",
  "preOrder.buyerProviderPrefix": "买家信息提供人-",
  "preOrder.confirm": "确认意向单",
  "preOrder.purchaseBusinessPrefix": "采购商务-",
  "preOrder.buyerRolePrefix": "买家-",
  "preOrder.clearSelection": "清除选中",
  "orderDetails.sampleTitle": "详情AAA",
  "orderDetails.sampleNumber": "订单编号A：",
  "preOrder.myEnquiries": "我的意向单",
  "inspection.myInspections": "我的验货",
  "inspection.pending": "待验货",
  "inspection.inspect": "去验货",
  "inspection.chooseWarehouse": "请选择入仓仓库",
  "inspection.chooseDate": "请选择入仓日期",
  "inspection.previousYear": "上一年",
  "inspection.nextYear": "下一年",
  "inspection.clearDate": "清空日期",
  "outboundAudit.companyLookupHint": "输入{field}查询",
  "tradeContract.installment": "分期",
  "tradeContract.fullPayment": "全款",
  "tradeContract.deleteFailed": "删除失败！请重试！",
  "orderFollow.claimSuccess": "抢单成功",
  "orderFollow.contactSellerHint": "您已成功接单，请尽快联系货主确认货源信息",
  "orderFollow.contactBuyerHint": "您已成功接单，请尽快联系买家确认意向单信息",
  "orderFollow.awaitSalesHint": "您已成功接单，请等待销售商务接单",
  "orderFollow.editContractHint": "您已成功接单，请前往编辑交易合同信息",
  "orderFollow.backToFollow": "返回跟单",
  "externalPayment.amount": "支付金额",
  "externalPayment.remainingTime": "支付剩余时间",
  "externalPayment.confirm": "确认支付",
  "externalPayment.title": "对外支付",
  "externalPayment.sellerAmount": "货主支付金额",
  "externalPayment.sellerStatus": "货主支付状态",
  "externalPayment.copySellerLink": "复制货主支付链接",
  "externalPayment.buyerAmount": "买家支付金额",
  "externalPayment.buyerStatus": "买家支付状态",
  "externalPayment.buyerTime": "买家支付时间",
  "externalPayment.copyBuyerLink": "复制买家支付链接",
  "outboundAudit.autoFillHint": "选择产品和入仓号后自动回填",
  "outboundAudit.remarkPlaceholder": "请输入审核备注（选填，最多200字）",
  "outboundAudit.reloadRemarks": "重新加载审核备注",
  "outboundAudit.reloadCc": "重新加载抄送人",
  "outboundAudit.rejectTitle": "驳回出库单",
  "outboundAudit.rejectReasonRequired": "请填写驳回原因（必填）",
  "outboundAudit.resubmit": "重新发起出库单审批",
  "outboundAudit.initiateReview": "发起出库单审核",
  "outboundAudit.initiateApproval": "发起出库单审批",
  "outboundAudit.resubmitConfirm": "确认重新发起该出库单审批？",
  "outboundAudit.submitConfirm": "确认提交该出库单审批？",
  "outboundAudit.approveConfirm": "确认审核通过该出库单？",
  "outboundAudit.reviewConfirmFailed": "审核确认失败，请重试",
  "outboundAudit.rejectConfirmFailed": "驳回确认失败，请重试",
  "outboundAudit.relatedOrderFailed": "关联订单加载失败，请返回后重试",
  "outboundAudit.relatedDataFailed": "出库单关联资料加载失败，请返回后重试",
  "outboundAudit.contractDetailFailed": "获取合同详情失败",
  "outboundAudit.enterNewNumber": "请输入新的出库单号",
  "outboundAudit.newNumberRequired": "重新发起审批请填写不同于原单的新出库单号",
  "outboundAudit.enterNumber": "请填写出库单号",
  "outboundAudit.remarksLoading": "审核备注加载中...",
  "outboundAudit.reviewersLoading": "审批人加载中...",
  "outboundAudit.noReviewers": "暂无审批人",
  "outboundAudit.noCc": "暂无抄送人",
  "outboundAudit.rejectReasonLimit": "驳回原因不能超过200字",
  "outboundAudit.rejectReasonHint": "请填写驳回原因（必填，最多200字）",
  "outboundAudit.productLabel": "产品{number}",
  "outboundAudit.collapseParty": "收起{party}信息",
  "outboundAudit.expandParty": "查看更多{party}信息",
  "orderFollow.myContracts": "我生成的合同",
  "orderFollow.trading": "交易中",
  "orderFollow.completed": "已完成",
  "orderFollow.awaitContractConfirmation": "待确认交易合同",
  "orderFollow.awaitSalesContract": "待销售商务生成交易合同",
  "orderFollow.awaitContractCreation": "待生成交易合同",
  "orderFollow.contractCreated": "已生成交易合同",
  "orderFollow.tradePrice": "交易价格",
  "orderFollow.tradeQuantity": "交易数量",
  "orderFollow.intermediateSellerCompany": "中间货主公司",
  "orderFollow.intermediateBuyerCompany": "中间买家公司",
  "orderFollow.orderCreatedAt": "订单生成时间",
  "orderFollow.sellerPrefix": "货主-",
  "orderFollow.purchaseNegotiatorPrefix": "采购谈判人-",
  "orderFollow.salesNegotiatorPrefix": "销售谈判人-",
  "orderFollow.salesBusinessPrefix": "销售商务-",
  "orderFollow.supervisorPrefix": "监督人-",
  "orderFollow.inspectorPrefix": "验货人-",
  "orderFollow.businessDetail": "商务跟单详情",
  "orderFollow.purchaseBusinessDetail": "采购商务-跟单详情",
  "orderFollow.salesBusinessDetail": "销售商务-跟单详情",
  "tradeContract.enterUnitPrice": "请填写商品单价",
  "tradeContract.enterQuantity": "请填写商品数量",
  "tradeContract.enterTotal": "请填写总金额",
  "tradeContract.sellerFee": "货主交易费",
  "tradeContract.enterSellerFee": "请填写货主应付交易费",
  "tradeContract.buyerFee": "买家交易费",
  "tradeContract.enterBuyerFee": "请填写买家应付交易费",
  "tradeContract.enterDeliveryDate": "请填写交货日期",
  "tradeContract.uploadDocuments": "上传合同资料",
  "tradeContract.enterAfterSalesTerms": "请输入售后条款",
  "tradeContract.confirmed": "确认合同成功！",
});

export const workflowFeedback = Object.freeze({
  "workflowFeedback.sellerCompany": "卖方公司",
  "workflowFeedback.buyerCompany": "买方公司",
  "workflowFeedback.bankAccountName": "银行账户名",
  "workflowFeedback.noPurchases": "暂无可选择的采购商品",
  "workflowFeedback.lockedPurchase": "该商品不能取消选择",
  "workflowFeedback.sameNegotiator": "买卖谈判人同一个",
  "workflowFeedback.sameBusiness": "买卖商务同一个",
  "workflowFeedback.reviewPermissionMissing": "暂无权限评价",
  "workflowFeedback.currentStage": "当前阶段：",
  "workflowFeedback.flowProgress": "流程 {current} / {total}",
  "workflowFeedback.splitCount": "拆分单数",
  "workflowFeedback.allocateQuantities": "分配拆分数量",
  "workflowFeedback.allocationHint": "每单数量之和需等于商品总数",
  "workflowFeedback.allocationComplete": "已分配完成",
  "workflowFeedback.remainingQuantity": "剩余 {quantity}",
  "workflowFeedback.selectablePeople": "可选{role}",
  "workflowFeedback.peopleCount": "共 {count} 人",
  "workflowFeedback.personSearchGuide": "输入{role}姓名搜索并添加",
  "workflowFeedback.ccSearchPlaceholder": "搜索抄送人姓名",
  "workflowFeedback.noSelectableCc": "暂无可选抄送人",
  "workflowFeedback.paymentInformation": "付款信息",
  "workflowFeedback.buyerDetails": "买方资料",
  "workflowFeedback.collapseSeller": "收起卖方资料",
  "workflowFeedback.collapseBuyer": "收起买家资料",
  "workflowFeedback.orderTotal": "订单总价",
  "workflowFeedback.tradingParties": "交易双方信息",
  "workflowFeedback.viewContract": "查看合同",
  "workflowFeedback.quick": "快捷",
  "workflowFeedback.createTradeOrder": "生成交易订单",
  "workflowFeedback.quickPurchaseOrder": "快捷生成采购订单",
  "workflowFeedback.blockInformation": "屏蔽该信息",
  "workflowFeedback.claimOrder": "抢单",
  "workflowFeedback.quickPurchaseContract": "快捷生成采购合同",
  "workflowFeedback.goPay": "去支付",
  "workflowFeedback.contractNumberPrefix": "合同号：",
  "workflowFeedback.goodsNumberPrefix": "商品号：",
  "workflowFeedback.confirmTradeOrder": "确认交易订单",
  "workflowFeedback.totalCny": "总金额 ¥",
  "workflowFeedback.acceptedAt": "接单时间：",
  "workflowFeedback.supplyClueNegotiator": "货源线索谈判人",
  "workflowFeedback.demandClueNegotiator": "求购线索谈判人",
  "workflowFeedback.supplyGoodsNegotiator": "货源商品谈判人",
  "workflowFeedback.purchaseGoodsNegotiator": "购买商品谈判人",
  "workflowFeedback.purchaseTradeNegotiator": "交易采购谈判人",
  "workflowFeedback.salesTradeNegotiator": "交易销售谈判人",
  "workflowFeedback.informationPrice": "信息价格",
  "workflowFeedback.originalPricePrefix": "商品原价：",
  "workflowFeedback.buyerProviderPrefix": "买方信息提供人：",
  "workflowFeedback.selectMultiple": "请选择（多选）",
  "workflowFeedback.reviewSucceeded": "{type}审核成功",
  "workflowFeedback.reviewRejected": "{type}已驳回",
  "workflowFeedback.conditionLoadFailed": "货物情况选项加载失败，可稍后重试",
  "workflowFeedback.purchaseItemsUpdated": "采购商品已更新",
  "workflowFeedback.keepCurrentPurchase": "至少保留当前采购商品",
  "workflowFeedback.negotiatorSearchFailed": "谈判人搜索失败",
  "workflowFeedback.sellerReviewersLoadFailed":
    "卖方审核人员加载失败，可稍后重试",
  "workflowFeedback.reviewersLoadFailed": "审核人员加载失败，可稍后重试",
  "workflowFeedback.ccSearchFailed": "搜索抄送人失败",
  "workflowFeedback.ccAdded": "抄送人已添加",
  "workflowFeedback.draftSaved": "草稿已保存",
  "workflowFeedback.draftSaveFailed": "草稿保存失败",
  "workflowFeedback.purchaseQuoteRequired": "请先完成采购报价",
  "workflowFeedback.purchaseUnavailable": "当前商品暂不允许生成采购订单",
  "workflowFeedback.purchaseCreated": "采购订单生成成功",
  "workflowFeedback.createOrderFailed": "生成订单失败",
  "workflowFeedback.purchaseQuoteSubmitted": "采购报价提交成功",
  "workflowFeedback.purchaseQuoteFailed": "采购报价提交失败",
  "workflowFeedback.sellerFieldRequired": "卖方{field}不能为空",
  "workflowFeedback.buyerFieldRequired": "买方{field}不能为空",
  "workflowFeedback.newClaimInformation": "新的抢单信息",
  "workflowFeedback.noClaimInformation": "暂无可抢单信息",
  "workflowFeedback.rejectFailed": "驳回失败",
  "workflowFeedback.installmentIncomplete":
    "请先填写完整{installment}的付款金额和付款时间",
  "workflowFeedback.installmentDateOrder":
    "{current}的付款时间不能早于{previous}的付款时间",
  "workflowFeedback.installmentProofRequired": "请上传{installment}的支付凭证",
  "workflowFeedback.installmentCompanyRequired":
    "请选择{installment}的下单公司",
  "workflowFeedback.installmentBankRequired": "请选择{installment}的付款银行",
  "workflowFeedback.reviewFailed": "审核失败",
  "workflowFeedback.inspectionMissing": "验货数据不存在",
  "workflowFeedback.warehouseQuantityLimit":
    "入仓明细实际数量之和不能大于{quantity}",
  "workflowFeedback.warehouseDeleteFailed": "删除入仓明细失败",
  "workflowFeedback.batchInspectionLoadFailed": "批量验货数据加载失败",
  "workflowFeedback.confirmBatchInspection":
    "确认后将提交 {count} 个商品的验货结果，是否继续？",
  "workflowFeedback.batchInspectionSaveFailed": "验货信息批量保存失败",
  "workflowFeedback.batchInspectionConfirmFailed": "批量确认验货失败",
  "workflowFeedback.batchInspectionRetry": "批量确认验货失败，请稍后重试",
  "workflowFeedback.uploadingBeforeSave": "图片或视频上传中，请稍后保存",
  "workflowFeedback.loadingBeforeSave": "数据加载中，请稍后保存",
  "workflowFeedback.inspectionSaveFailed": "验货信息保存失败",
  "workflowFeedback.inspectionSaveRetry": "验货信息保存失败，请稍后重试",
  "workflowFeedback.inspectionConfirmRetry": "确认验货失败，请稍后重试",
  "workflowFeedback.rejectRefresh": "驳回失败，请刷新后重试",
  "workflowFeedback.selectedGoodsCount": "已选择 {selected} / {total} 个{item}",
  "workflowFeedback.viewPaymentReview": "查看付款审核",
  "workflowFeedback.viewPurchaseOrder": "查看采购订单",
  "workflowFeedback.viewPurchaseContract": "查看采购合同",
  "workflowFeedback.purchaseGoodsRequired": "请至少选择一个采购商品",
  "workflowFeedback.purchaseGoodsFields": "请完善商品{index}的必填信息",
});

export const sharedFlowUi = Object.freeze({
  "workflowFeedback.finalPayment": "尾款",
  "workflowFeedback.buyerNotReceived": "*【销售-买家】还未收货，请慎重确认！",
  "workflowFeedback.piProof": "PI 发票凭证",
  "workflowFeedback.ciProof": "CI 发票凭证",
  "workflowFeedback.paymentAuthorization": "付款委托书",
  "workflowFeedback.invoiceUploadIntro": "发票上传说明",
  "workflowFeedback.shippingEvidenceRequired": "发货凭证与发货备注至少填写一项",
  "workflowFeedback.shippingNotePlaceholder":
    "可补充配送要求、预计送达时间等信息（选填）",
  "workflowFeedback.invoiced": "已开票",
  "workflowFeedback.paymentEnded": "已结束",
  "workflowFeedback.totalReceivable": "应收总额",
  "workflowFeedback.endPaymentHint": "开启后表示该订单无需继续补充付款凭证",
  "workflowFeedback.pendingOrderInformation": "待确认订单信息",
  "workflowFeedback.receiptSummary": "收款汇总",
  "workflowFeedback.noPaymentProofHint":
    "暂无付款凭证，请先与买方核实款项到账情况",
  "workflowFeedback.notInvoiced": "未开票",
  "workflowFeedback.paymentNotEnded": "未结束",
  "workflowFeedback.endPayment": "本次付款是否结束",
  "workflowFeedback.viewOrderNodes": "查看订单、合同与付款节点",
  "workflowFeedback.checkOrderInformation": "核对商品、付款与开票信息",
  "workflowFeedback.viewProofHint": "点击凭证可查看文件详情",
  "workflowFeedback.logisticsInformation": "物流信息",
  "workflowFeedback.logisticsNotes": "物流备注",
  "workflowFeedback.receiptConfirmHint":
    "确认后将记录本次收款结果，请确保实际款项已到账。",
  "workflowFeedback.orderInvoiceProof": "订单开票凭证",
  "workflowFeedback.orderTotalAmount": "订单总金额",
  "workflowFeedback.requiredFields": "请填写必填项！",
  "workflowFeedback.addressRequired": "请新增或更换收货地址",
  "workflowFeedback.paymentProofRequired": "请至少上传一份支付凭证",
  "workflowFeedback.paymentProofRequiredAlert": "请至少上传一份支付凭证！",
  "workflowFeedback.logisticsCompanyRequired": "请输入物流公司名称",
  "workflowFeedback.invoiceCount": "已添加{count}个发票文件，可确认上传",
  "workflowFeedback.invoiceRequired": "请至少添加一份发票后再确认上传",
  "workflowFeedback.receiptCheckHint": "请在核对商品及随货资料无误后完成确认",
  "workflowFeedback.notConfirmYet": "暂不确认",
  "workflowFeedback.shippingIntro": "填写本次发货信息，便于买家及时跟踪物流",
  "workflowFeedback.checkReceiptHint": "请核对订单、收款金额与付款凭证",
  "workflowFeedback.payerCompany": "付款公司（买方）",
  "workflowFeedback.payeeCompany": "收款公司（卖方）",
  "workflowChat.agentManager": "群管理：群聊Agent",
  "workflowChat.groupInitial": "群",
  "workflowChat.groupSettings": "群聊设置（{count}人）",
  "workflowChat.privateChat": "私聊",
  "workflowChat.mention": "提醒成员",
  "workflowChat.mentionedMe": "有人@我",
  "workflowChatAgent.readOnly": "只读分析",
  "workflowChat.agentName": "群聊Agent",
  "workflowChat.purchaseOrderName": "采购 ",
  "workflowChat.saleOrderName": "销售 ",
  "workflowChat.purchaseDraftName": "采购草稿 ",
  "workflowChat.saleDraftName": "销售草稿 ",
  "workflowChat.orderCount": "（{count}单）",
  "workflowChat.dateUnknown": "日期待确认",
  "workflowChat.progress.DRAFT": "待发起",
  "workflowChat.progress.COMPLETED": "交易完成",
  "workflowChat.progress.REJECTED": "审批已驳回",
  "workflowChat.progress.INVALID": "订单已失效",
  "workflowChat.progress.CLOSED": "交易关闭",
  "workflowChat.progress.WAITING_BUSINESS_CONFIRMATION": "待商务确认",
  "workflowChat.progress.WAITING_PAYMENT": "待付款",
  "workflowChat.progress.WAITING_PAYMENT_PROOF": "待上传付款凭据",
  "workflowChat.progress.WAITING_PAYMENT_CONFIRMATION": "待确认收款",
  "workflowChat.progress.WAITING_SHIPMENT": "待发货",
  "workflowChat.progress.WAITING_RECEIPT": "待确认收货",
  "workflowChat.progress.RECEIPT_CONFIRMED": "已确认收货",
  "workflowChat.progress.REVIEW_APPROVED": "审核已通过",
  "workflowChat.progress.OUTBOUND_REVIEW": "出库审批",
  "workflowChat.progress.OUTBOUND_REJECTED": "出库审批驳回",
  "workflowChat.progress.PROGRESS_UNAVAILABLE": "进度待确认",
  "workflowChat.progress.REVIEW_1": "订单审核",
  "workflowChat.progress.REVIEW_1_REJECTED": "订单审核驳回",
  "workflowChat.progress.REVIEW_2": "合同审批",
  "workflowChat.progress.REVIEW_2_REJECTED": "合同审批驳回",
  "workflowChat.progress.REVIEW_3": "付款审批",
  "workflowChat.progress.REVIEW_3_REJECTED": "付款审批驳回",
  "workflowChat.progress.REVIEW_4": "付款方式审批",
  "workflowChat.progress.REVIEW_4_REJECTED": "付款方式审批驳回",
  "workflowChat.progress.REVIEW_5": "INV审批",
  "workflowChat.progress.REVIEW_5_REJECTED": "INV审批驳回",
  "workflowChat.progress.REVIEW_6": "出货审批",
  "workflowChat.progress.REVIEW_6_REJECTED": "出货审批驳回",
  "workflowChat.fullChain": "全流程协作",
  "workflowChat.allMembers": "所有人",
  "workflowChat.draftUnavailable": "未找到已保存的草稿，请先暂存后重试。",
  "workflowChat.scopeUnavailable": "当前页面的审批链尚未准备好，或无法唯一确定付款批次。",
  "workflowChat.entry": "流程协作",
  "workflowChat.title": "流程协作群",
  "workflowChat.currentScope": "当前单据流程",
  "workflowChat.selectScope": "选择流程",
  "workflowChat.active": "讨论中",
  "workflowChat.archived": "已归档",
  "workflowChat.cooling": "结束后讨论期",
  "workflowChat.readonly": "只读归档",
  "workflowChat.round": "第{number}轮",
  "workflowChat.unread": "{count}条未读",
  "workflowChat.noArchived": "暂无归档讨论",
  "workflowChat.noActive": "暂无活跃讨论",
  "workflowChat.loadMoreGroups": "加载更多群",
  "workflowChat.archiveAt": "{time}转为只读归档",
  "workflowChat.memberCount": "讨论成员（{count}）",
  "workflowChat.history": "流程聊天记录",
  "workflowChat.viewingReference": "引用消息 #{number}",
  "workflowChat.laterMessages": "后续消息",
  "workflowChat.returnToChat": "返回聊天",
  "workflowChat.referenceUnavailable": "该引用消息暂不可查看",
  "workflowChat.earlierMessages": "查看更早记录",
  "workflowChat.noMessages": "暂无讨论消息",
  "workflowChat.newMessages": "查看新消息",
  "workflowChat.messagePlaceholder":
    "说明情况，与当前流程成员讨论。Enter发送，Shift+Enter换行",
  "workflowChat.archivedHint": "此轮讨论已归档，可查看历史记录。",
  "workflowChat.participantsHint": "将自动纳入以下流程成员：",
  "workflowChat.retentionHint":
    "流程结束后保留7天讨论，之后只读归档，聊天记录保留。",
  "workflowChat.openingPlaceholder": "填写发起讨论的原因及需要协商的事项",
  "workflowChat.start": "发起流程讨论",
  "workflowChat.ccPermissionHint":
    "抄送人可参与已有讨论；仅发起人和审核人可建群。",
  "workflowChat.emptyHint": "从左侧选择讨论，或从单据审批页面发起流程讨论。",
  "workflowChat.roleSeparator": "、",
  "workflowChat.orderApproval": "订单审批",
  "workflowChat.contractApproval": "合同审批",
  "workflowChat.paymentApproval": "付款审批",
  "workflowChat.paymentMethodApproval": "付款方式审批",
  "workflowChat.invoiceApproval": "发票审批",
  "workflowChat.outboundApproval": "出库审批",
  "workflowChat.discussion": "流程讨论",
  "workflowChat.scopeInstallment": "{scope} · 第{number}期",
  "workflowFeedback.installmentNumber": "第{number}期",
});

// 移动端订单、合同及验货流程的增量显示文案。
export const mobileWorkflowFollowup = Object.freeze({
  "mobileOrderWorkflow.awaitSellerDualStamp": "待货主上传双章合同",
  "mobileOrderWorkflow.awaitBuyerDualStamp": "待买家上传双章合同",
  "mobileOrderWorkflow.awaitBusinessDualStamp": "待商务上传双章合同",
  "mobileOrderWorkflow.awaitSellerStamp": "待货主上传盖章合同",
  "mobileOrderWorkflow.awaitBuyerStamp": "待买家上传盖章合同",
  "mobileOrderWorkflow.paymentReviewUnderReview": "付款流程审核中",
  "mobileOrderWorkflow.paymentReviewRejected": "付款流程已驳回",
  "mobileOrderWorkflow.paymentMethodUnderReview": "付款方式审核中",
  "mobileOrderWorkflow.paymentMethodRejected": "付款方式已驳回",
  "mobileOrderWorkflow.invoiceUnderReview": "INV审核中",
  "mobileOrderWorkflow.invoiceRejected": "INV审核已驳回",
  "mobileOrderWorkflow.confirmInvoiceApproval": "确认INV审批",
  "mobileOrderWorkflow.viewInvoiceApproval": "查看INV审批",
  "mobileOrderWorkflow.itemCountOne": "{count} 项",
  "mobileOrderWorkflow.itemCountMany": "{count} 项",
  "mobileOrderWorkflow.supportedFileTypes": "支持上传多种类型文件",
  "mobileOrderWorkflow.invoiceFile": "INV（正式发票）",
  "mobileOrderWorkflow.paymentReviewOpinion": "填写本次付款审核处理意见",
  "mobileOrderWorkflow.noMergeableOrders": "暂无可合并订单",
  "mobileOrderWorkflow.noOtherMergeableOrders": "当前没有其他可合并订单",
  "mobileOrderWorkflow.packagingImages": "包装图片",
  "mobileOrderWorkflow.packagingVideos": "包装视频",
  "mobileOrderWorkflow.detailImages": "细节图片",
  "mobileOrderWorkflow.detailVideos": "细节视频",
  "mobileOrderWorkflow.addShortVideo": "添加短视频",
  "mobileOrderWorkflow.financeRole": "财务",
  "mobileOrderWorkflow.salesContractNotSubmitted": "销售合同未提交",
  "mobileOrderWorkflow.buyerContractNotSubmitted": "买家合同未提交",
  "mobileOrderWorkflow.sellerContractNotSubmitted": "货主未提交合同",
  "mobileOrderWorkflow.invoiceContractNotReviewed": "待发起INV审核【未复核合同】",
  "mobileOrderWorkflow.orderAcceptedBy": "{name}接单",
  "mobileOrderWorkflow.awaitRoleReview": "待{role}审核",
  "mobileOrderWorkflow.purchaseOrderCreated": "采购订单已生成",
  "mobileOrderWorkflow.purchaseOrderNotCreated": "采购订单未生成",
  "mobileOrderWorkflow.salesOrderCreated": "销售订单已生成",
  "mobileOrderWorkflow.salesOrderNotCreated": "销售订单未生成",
  "mobileOrderWorkflow.purchaseContractSubmitted": "采购合同已提交",
  "mobileOrderWorkflow.purchaseContractNotSubmitted": "采购合同未提交",
  "mobileOrderWorkflow.purchaseTemplateSubmitted": "采购合同模板已提交",
  "mobileOrderWorkflow.salesContractSubmitted": "销售合同已提交",
  "mobileOrderWorkflow.salesContractNotCreated": "销售合同未生成",
  "mobileOrderWorkflow.awaitSellerReview": "待货主审核",
  "mobileOrderWorkflow.awaitBuyerReview": "待买家审核",
  "mobileOrderWorkflow.buyerReviewed": "买家已审核",
  "mobileOrderWorkflow.awaitBusinessStamp": "待商务上传盖章合同",
  "mobileOrderWorkflow.awaitSellerProductLink": "待货主绑定商品",
  "mobileOrderWorkflow.sellerProductLinked": "货主已绑定商品",
  "mobileOrderWorkflow.purchaseQuoted": "已采购报价",
  "mobileOrderWorkflow.awaitBusinessInspection": "待商务验货",
  "mobileOrderWorkflow.awaitManagerInspection": "待商务经理验货",
  "mobileOrderWorkflow.inspectionCompleted": "验货完成",
  "mobileOrderWorkflow.awaitDualStamp": "待上传双章合同",
  "mobileOrderWorkflow.dualStampUploaded": "已上传双章合同",
  "mobileOrderWorkflow.awaitPaymentProof": "待上传付款凭证",
  "mobileOrderWorkflow.awaitPaymentProofConfirmation": "待确认付款凭证",
  "mobileOrderWorkflow.paymentProofConfirmed": "已确认付款凭证",
  "mobileOrderWorkflow.paymentReviewFlow": "付款审核流程",
  "mobileOrderWorkflow.reviewPaymentWorkflow": "付款流程审核",
  "mobileOrderWorkflow.sellerReceiptConfirmed": "卖家已确认收款",
  "mobileOrderWorkflow.awaitBuyerPayment": "待买家付款",
  "mobileOrderWorkflow.buyerPaid": "买家已付款",
  "mobileOrderWorkflow.financeReceiptConfirmed": "财务确认收款",
  "mobileOrderWorkflow.customerReceived": "客户已收货",
  "mobileOrderWorkflow.sellerShipped": "卖家已发货",
  "mobileOrderWorkflow.sellerNotShipped": "卖家未发货",
  "mobileOrderWorkflow.notShipped": "未发货",
  "mobileOrderWorkflow.reviewCompleted": "审核完成",
  "mobileOrderWorkflow.reviewRecordMissing": "审核记录未生成",
  "mobileOrderWorkflow.paymentReviewCompleted": "付款流程审核完成",
  "mobileOrderWorkflow.paymentReviewRecordMissing": "付款流程审核记录未生成",
  "mobileOrderWorkflow.paymentReviewNotStarted": "付款流程待发起",
  "mobileOrderWorkflow.paymentMethodReviewed": "付款方式审核完成",
  "mobileOrderWorkflow.paymentMethodNotStarted": "付款方式待发起",
  "mobileOrderWorkflow.invoiceReviewNotStarted": "待发起INV审核",
  "mobileOrderWorkflow.invoiceNotStarted": "待发起INV",
  "mobileOrderWorkflow.invoiceReviewed": "INV审核完成",
  "mobileOrderWorkflow.accountant": "会计",
  "mobileOrderWorkflow.cashier": "出纳",
  "mobileOrderWorkflow.reviewPurchaseOrder": "审核采购订单",
  "mobileOrderWorkflow.confirmPurchaseOrder": "确认采购订单",
  "mobileOrderWorkflow.confirmContract": "确认合同",
  "mobileOrderWorkflow.confirmInvoice": "确认INV",
  "mobileOrderWorkflow.confirmPaymentApproval": "确定付款审批",
  "mobileOrderWorkflow.viewPaymentApproval": "查看付款审批",
  "mobileOrderWorkflow.startPaymentMethodApproval": "发起付款方式审批",
  "mobileOrderWorkflow.ownerNotReviewed": "货主未审核",
  "mobileOrderWorkflow.ownerReviewed": "货主已审核",
  "mobileOrderWorkflow.paymentNotSubmitted": "付款流程未提交",
  "mobileOrderWorkflow.paymentUnderReview": "付款审核中",
  "mobileOrderWorkflow.paymentComplete": "付款完成",
  "mobileOrderWorkflow.pendingPayment": "待付款",
  "mobileOrderWorkflow.paid": "已付款",
  "mobileOrderWorkflow.paying": "付款中",
  "mobileOrderWorkflow.paymentFailed": "付款失败",
  "mobileOrderWorkflow.purchasePaymentContract": "采购付款合同",
  "mobileOrderWorkflow.standardContract": "普通合同",
  "mobileOrderWorkflow.approvalEnded": "审批已结束",
  "mobileOrderWorkflow.orderCompleted": "订单完成",
  "mobileOrderWorkflow.fillRemarks": "填写备注",
  "mobileOrderWorkflow.paymentUnavailable": "暂时无法获取付款信息",
  "mobileOrderWorkflow.networkRetry": "网络异常，请稍后重试",
  "mobileOrderWorkflow.initiateWithoutPi": "供应商还未上传PI，确认发起付款审批？",
  "mobileOrderWorkflow.initiatePaymentConfirmation": "确认发起付款审核？",
  "mobileOrderWorkflow.approveOrderConfirmation": "确认订单审核通过？",
  "mobileOrderWorkflow.approveContractConfirmation": "确认合同审核通过？",
  "mobileOrderWorkflow.contractRelatedHint": "选择需要关联到当前合同审批的历史订单、合同或付款审核记录",
  "mobileOrderWorkflow.inspectionOrderLoading": "订单号待加载",
  "mobileOrderWorkflow.inspectionGoodsRequired": "缺少商品编号，请返回订单页重新进入",
  "mobileOrderWorkflow.inspectionLoadFailed": "加载商品失败",
  "mobileOrderWorkflow.inspectionStatusLoadFailed": "加载验货状态失败",
  "mobileOrderWorkflow.inspectionRetry": "加载失败，请稍后重试",
  "mobileOrderWorkflow.inspectionReadFailed": "验货数据读取失败",
  "mobileOrderWorkflow.inspectionSelectionMissing": "未找到已选商品",
  "mobileOrderWorkflow.inspectionAttachment": "验货附件",
  "mobileOrderWorkflow.inspectionProductLabel": "商品{number}",
  "mobileOrderWorkflow.warehouseUnified": "已统一到其他 {count} 个商品",
  "mobileOrderWorkflow.inspectionBatchConfirmed": "已批量确认 {count} 个商品",
  "mobileOrderWorkflow.productDataLoadFailed": "{name}数据加载失败",
  "mobileOrderWorkflow.productInspectionNotAllowed": "{name}当前状态不允许确认验货",
  "mobileOrderWorkflow.productApprovalRemarkRequired": "{name}的审批备注不能为空",
  "mobileOrderWorkflow.productWarehouseQuantityRequired": "{name}的每项入仓实际数量都必须大于0",
  "mobileOrderWorkflow.goodsRequiredInfo": "商品必填信息",
  "mobileOrderWorkflow.productRequiredInfo": "产品必填信息",
  "mobileOrderWorkflow.partiesRequiredInfo": "交易双方必填信息",
  "mobileOrderWorkflow.reviewerInfo": "审核人信息",
  "mobileOrderWorkflow.noProductProviders": "暂无可选商品提供人",
  "mobileOrderWorkflow.buyerContactPhone": "买方联系电话",
  "mobileOrderWorkflow.orderLoadFailed": "订单信息加载失败",
  "mobileOrderWorkflow.purchaseAccessDenied": "当前账号无权限查看生成采购订单，请切换采购商务账号。",
  "mobileOrderWorkflow.orderLoadRetry": "订单信息加载失败，请返回首页后重试。",
  "mobileOrderWorkflow.goodsLoadFailed": "获取商品信息失败",
  "mobileOrderWorkflow.draftSaved": "保存草稿成功",
  "mobileOrderWorkflow.salesMergedContract": "销售商务快捷合并交易合同",
  "mobileOrderWorkflow.sellerProvider": "货主信息提供人",
  "mobileOrderWorkflow.buyerProvider": "买家信息提供人",
  "mobileOrderWorkflow.deliveryNote": "送货单",
  "mobileOrderWorkflow.inspectGoodsLoadFailed": "获取验货商品列表失败"
});

export const messages = Object.freeze({
  ...mobileWorkflowFollowup,
  ...sharedFlowUi,
  ...workflowFeedback,
  ...mobileWorkflow,
  "purchasePayment.supplierPiMissingApprovalConfirm":
    "供应商还未上传PI，确定审核通过？",
  "purchasePayment.approvalConfirm": "确认付款审核通过？",
  ...contractFlow,
  ...outboundList,
  ...buy,
  ...contact,
  ...broker,
  ...checkout,
  ...mobileComponents,
  ...mobile,
  ...mobileCart,
  ...mobileTransactions,
  ...details,
  ...desktopCart,
  ...contractReview,
  ...follow,
  ...desktopComponents,
  ...desktopTransactions,
  ...personal,
  ...split,
  "outboundAudit.priceUnit": "价格单位",
  "outboundAudit.goodsQuantity": "订单数量",
  "outboundAudit.warehouseQuantity": "入仓数量",
  "outboundAudit.stockQuantity": "库存数量",
});
